<div fxLayout="row" fxLayoutAlign="center center" style="padding: 0px" [ngStyle]="{'height': availableHeight ? height+'px' : 'initial'}">
    <mat-spinner [diameter]="diameter" [ngClass]="class ? 'custom-spinner' : ''"></mat-spinner>
</div>